module.exports = __webpack_public_path__ + "static_pest_wiki_details/img/profession_infobanner02.af352c3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pc/product_info/profession_infobanner02.jpg
// module id = DaIa
// module chunks = 0